"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  backdropFilter: 'blur(1px)',
  backgroundColor: (0, _mui.alpha)(theme.palette.common.white, 0.45),
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  position: 'absolute',
  textAlign: 'center',
  width: '100%',
  zIndex: 3,
  svg: {
    color: theme.palette.primary.dark
  }
}));
